import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import ForumApplication from 'flarum/forum/ForumApplication';
import LogInModal from 'flarum/forum/components/LogInModal';

import { ATTRIBUTES, EXTENSION_ID } from '../common/settings';
import LoginMessage from './components/LoginMessage';

export { default as LoginMessage } from './components/LoginMessage';

app.initializers.add(EXTENSION_ID, () => {
  /*
   * Show the configured notice above the log in modal's input fields.
   *
   * Core adds its fields at priorities 30 (identification) down to -10 (submit),
   * so anything above 30 lands on top of them.
   */
  extend(LogInModal.prototype, 'fields', function (items) {
    const message = app.forum.attribute(ATTRIBUTES.loginMessage);

    if (!message || !String(message).trim()) return;

    items.add(
      'holz100StatikAppMessage',
      <LoginMessage message={message} variant={app.forum.attribute(ATTRIBUTES.messageStyle)} />,
      100
    );
  });

  /*
   * Optionally widen the modal, for when the message is long.
   *
   * This only swaps out core's own size classes, so the responsive rules come
   * along unchanged: `.Modal` keeps `width: 100%`, the max-widths only apply
   * from the tablet breakpoint upwards, and phones stay at full width. That
   * means the modal can never grow past the viewport.
   */
  override(LogInModal.prototype, 'className', function (original) {
    const width = app.forum.attribute(ATTRIBUTES.modalWidth);
    const className = original();

    if (width === 'medium') return className.replace('Modal--small', '').trim();
    if (width === 'large') return className.replace('Modal--small', 'Modal--large');

    return className;
  });

  /*
   * Open the log in modal right away when a guest opens the forum.
   *
   * `mount()` runs once per full page load (not on in-app navigation), which is
   * exactly the "user opens the forum" moment. Deferring by a tick avoids the
   * nested-redraw quirk documented on `app.modal.show()`.
   */
  extend(ForumApplication.prototype, 'mount', function () {
    if (app.session.user) return;
    if (!app.forum.attribute(ATTRIBUTES.autoOpenLogin)) return;

    setTimeout(() => {
      // Don't fight with a modal that core or another extension already opened,
      // e.g. the password reset modal coming from an e-mail link.
      if (app.modal.isModalOpen()) return;

      app.modal.show(LogInModal);
    }, 0);
  });
});
